import React from "react";
import axios from "axios";

import { Button, Dialog, FormControl, InputLabel, Snackbar, SnackbarCloseReason, Typography } from "@material-ui/core";
import { BootstrapInput } from "../../pages/contact/contact.us";
import { SERVER_API_ORDERS } from "../../redux/api.constants";

import s from './ManageOrdersDialog.module.scss'

interface ManageOrdersDialogProps {
    openManageOrdersPopup: boolean;
    onClose: () => void;
    setIsAuth: (val: boolean) => void;
};

export const ManageOrdersDialog = ({ openManageOrdersPopup, onClose, setIsAuth }: ManageOrdersDialogProps) => {

    const [userData, setUserData] = React.useState({
        email: '',
        password: ''
    });

    const [errorEmail, setErrorEmail] = React.useState(false);
    const [errorPassword, setErrorPassword] = React.useState(false);

    const [openSnackbar, setOpenSnackbar] = React.useState(false);

    const handleCloseSnackbar = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const isNotValid = !userData.email || !userData.password || errorEmail || errorPassword

    const handleChangeField = (field: 'email' | 'password') => (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserData({
            ...userData,
            [field]: event.target.value
        });

        if (field === 'email') {
            const isValidEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value);
            setErrorEmail(!isValidEmail);
        }

        if (field === 'password') {
            setErrorPassword(event.target.value.length < 4);
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const { email, password } = userData;

        if (isNotValid) return;

        try {
            const response = await axios.post(`${SERVER_API_ORDERS}/auth`, {
                email: email,
                password,
            }, { withCredentials: true });

            if (!response.data?.accessToken) throw new Error("No Token")

            localStorage.setItem("accessToken", response.data?.accessToken)
            setIsAuth(true);

            onClose();
        } catch (error) {
            setOpenSnackbar(true);
            console.info('Error during submission:', error);
        }
    };

    return (
        <>
            <Dialog open={openManageOrdersPopup} onClose={onClose} disableBackdropClick>
                <form className={s.form} onSubmit={handleSubmit}>
                    <Typography className={s.title}>Sign in to Access Order Management</Typography >

                    <div className={s.inputs_wrapper}>

                        <FormControl className={s.field_container}>
                            <InputLabel shrink htmlFor="email-input" className={s.label}>
                                Email <span className={s.red}>*</span>
                            </InputLabel>
                            <BootstrapInput
                                className={errorEmail ? s.field_error : s.field}
                                required
                                id="email-input"
                                value={userData.email}
                                placeholder={'eurotech@eurotech.com'}
                                onChange={handleChangeField('email')}
                            />
                        </FormControl>

                        <FormControl className={s.field_container}>
                            <InputLabel shrink htmlFor="password-input" className={s.label}>
                                Password <span className={s.red}>*</span>
                            </InputLabel>
                            <BootstrapInput
                                className={errorPassword ? s.field_error : s.field}
                                required
                                id="password-input"
                                type="password"
                                value={userData.password}
                                placeholder={'Enter your password'}
                                onChange={handleChangeField('password')}
                            />
                        </FormControl>

                        <Button
                            disabled={isNotValid}
                            style={{ backgroundColor: isNotValid ? 'gray' : 'black', color: 'white', padding: "20.5px" }}
                            fullWidth
                            type="submit">Confirm</Button>

                        <span className={s.link}>By entering your email, you agree to Eurotech's <a className={s.redLink} href="/privacy-policy">terms of service</a> and <a className={s.redLink} href="/privacy-policy" >privacy policy.</a></span>
                    </div>
                </form>
            </Dialog>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message="Invalid email or password."
            />
        </>
    );
};
